// Simple pub/sub to hide brain chat during onboarding flow
type Listener = (hidden: boolean) => void;

let _hidden = false;
const _listeners = new Set<Listener>();

export function setBrainChatHidden(hidden: boolean) {
  if (_hidden === hidden) return;
  _hidden = hidden;
  _listeners.forEach((fn) => fn(_hidden));
}

export function isBrainChatHidden() {
  return _hidden;
}

export function subscribeBrainChatVisibility(fn: Listener): () => void {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}
